import $ from './$';

export default $(document);
